/* eslint-disable import/prefer-default-export */
export const dayArrayMondayFirst = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
